import React, { useEffect, useRef, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { FaBell, FaRegCommentDots } from "react-icons/fa";
import { MdDashboard, MdListAlt, MdShoppingCart, MdPeople } from "react-icons/md";
import "./layout.css";
import * as apicall from "../../components/Apicall";
import NotificationModal from "./NotificationModal";
import { toast } from "react-toastify";

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showMessages, setShowMessages] = useState(false);
  const [unreadCount, setUnreadCount] = useState();
  const [messages, setMessages] = useState();
console.log(messages,"messages")
  const [showNotifs, setShowNotifs] = useState(false);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState();
  const [notificationsData, setNotificationsData] = useState([]);
  const [chatContext, setChatContext] = useState({ rfq: null, supplier: null });

  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  const isDashboard = ["/dashboard", "/rfq", "/rfq2"].some((p) =>
    location.pathname.startsWith(p)
  );
  const isQuotation = ["/vendor_quatation", "/vendor_quatation_details", "/vendor_quatation_form"].some((p) =>
    location.pathname.startsWith(p)
  );
  const isUserQuotation = ["/quatation", "/quotationDetails", "/reviewQuatation"].some((p) =>
    location.pathname.startsWith(p)
  );
  const isSuppliers = ["/suppliers", "/supplierProfile"].some((p) => location.pathname.startsWith(p));
  const isOrders = ["/orders", "/orderDetails","/vendor_order_details"].some((p) => location.pathname.startsWith(p));
  const isAdminDashboard = ["/admindashboard"].some((p) => location.pathname.startsWith(p));
  const isAdminsupplier = ["/adminsupplier"].some((p) => location.pathname.startsWith(p));
  const isAdminBuyer = ["/adminbuyer"].some((p) => location.pathname.startsWith(p));

  const chatOpenedRef = useRef(false);

  // Open chat if state passed
  useEffect(() => {
    if (location.state?.openChat && !chatOpenedRef.current) {
      chatOpenedRef.current = true;
      setChatContext({ rfq: location.state.rfq, supplier: location.state.supplierId });
      setShowMessages(true);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const user_id = userDetails?.id;

  const getMessages = async () => {
    try {
      const res = await apicall.get(`messages/${user_id}`);
      console.log(res,"res")
      setMessages(res.data);
    } catch (e) {
      console.error("getMessages error:", e);
      toast.error("Error loading messages");
    }
  };

  const fetchUnread = async () => {
    try {
      const res = await apicall.get(`unreadCount/${userDetails?.id}`);
      setUnreadCount(res.data[0]?.unread);
    } catch (err) {
      console.log("Unread count error", err);
    }
  };

  const fetchNotifications = async () => {
    try {
      const res = await apicall.get(`notifications/${userDetails?.id}`);
      setNotificationsData(res.data);
      const unreadNotifs = res.data.filter((x) => x.is_read === 0);
      setUnreadNotificationsCount(unreadNotifs.length);
    } catch (err) {
      console.log("Notification fetch error", err);
    }
  };

  const markAllNotifications = async () => {
    try {
      if (!notificationsData.length) return;
      const ids = notificationsData.map(n => n.id);
      const res = await apicall.post({ ids }, "notification_readStatus");

      if (res?.success) {
        window.location.reload();
      } else {
        toast.error(res?.message || "Failed to mark notifications");
      }
    } catch (err) {
      console.log("Error marking notifications", err);
    }
  };

  const openChatWindow = () => {
    if (!messages || messages === 0) return;
    localStorage.setItem("chatContext", JSON.stringify(chatContext));
    window.open("/chat", "_blank");
    fetchUnread();
  };

  useEffect(() => {
    fetchUnread();
    fetchNotifications();
    getMessages();
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      fetchUnread();
      fetchNotifications();
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <div className="app-container">
      {/* --------------------------- SIDEBAR --------------------------- */}
      <aside className="sidebar">
        <div className="logo">
          <img src="/images/logo.png" alt="UtilStop" />
        </div>
        <nav className="menu">
          {userDetails?.company_type_id === 2 && (
            <>
              <NavLink to="/dashboard" className={isDashboard ? "menu-item active" : "menu-item"}>
                <MdDashboard /> Dashboard
              </NavLink>
              <NavLink to="/vendor_quatation" className={isQuotation ? "menu-item active" : "menu-item"}>
                <MdListAlt /> Quotations
              </NavLink>
              <NavLink to="/orders" className={isOrders ? "menu-item active" : "menu-item"}>
                <MdShoppingCart /> Orders
              </NavLink>
              <NavLink to="/users" className="menu-item">
                <MdPeople /> Users
              </NavLink>
            </>
          )}

          {userDetails?.company_type_id === 1 && (
            <>
              <NavLink to="/dashboard" className={isDashboard ? "menu-item active" : "menu-item"}>
                <MdDashboard /> Dashboard
              </NavLink>
              <NavLink to="/quatation" className={isUserQuotation ? "menu-item active" : "menu-item"}>
                <MdListAlt /> Quotations
              </NavLink>
              <NavLink to="/orders" className={isOrders ? "menu-item active" : "menu-item"}>
                <MdShoppingCart /> Orders
              </NavLink>
              <NavLink to="/suppliers" className={isSuppliers ? "menu-item active" : "menu-item"}>
                <MdPeople /> Suppliers
              </NavLink>
              <NavLink to="/users" className="menu-item">
                <MdPeople /> Users
              </NavLink>
            </>
          )}

          {userDetails?.role === 1 && (
            <>
              <NavLink to="/admindashboard" className={isAdminDashboard ? "menu-item active" : "menu-item"}>
                <MdDashboard /> Dashboard
              </NavLink>
              <NavLink to="/adminsupplier" className={isAdminsupplier ? "menu-item active" : "menu-item"}>
                <MdListAlt /> Suppliers
              </NavLink>
              <NavLink to="/adminbuyer" className={isAdminBuyer ? "menu-item active" : "menu-item"}>
                <MdShoppingCart /> Buyers
              </NavLink>
            </>
          )}
        </nav>
      </aside>

      {/* --------------------------- MAIN AREA --------------------------- */}
      <div className="main">
        {/* ---------------------- HEADER ---------------------- */}
        <header className="topbar d-flex justify-content-end align-items-center p-2">
          <div className="bell-wrapper" style={{ position: "relative" }}>
            <FaBell
              className="icon me-3 fs-5"
              style={{ cursor: "pointer" }}
              onClick={() => setShowNotifs(!showNotifs)}
            />
            {unreadNotificationsCount > 0 && (
              <span className="notif-count">{unreadNotificationsCount}</span>
            )}
            <NotificationModal
              show={showNotifs}
              onClose={() => setShowNotifs(false)}
              notifications={notificationsData}
              onMarkAll={markAllNotifications}
            />
          </div>

          {/* Floating Chat Button */}
          {messages?.length > 0 && (
            <div className="chat-btn-wrapper">
              <button onClick={openChatWindow} title="Open Messages" className="chat-btn">
                <FaRegCommentDots size={22} />
                {unreadCount > 0 && <span className="chat-badge">{unreadCount}</span>}
              </button>
            </div>
          )}

          <div className="dropdown ms-3">
            <button
              className="btn dropdown-toggle border-0 bg-transparent"
              id="profileMenu"
              data-bs-toggle="dropdown"
            >
              <img src="/images/logo.png" alt="User" className="rounded-circle" style={{ width: 40, height: 40 }} />
            </button>

            <ul className="dropdown-menu dropdown-menu-end">
              {(Number(userDetails?.role) === 1 || userDetails?.is_primary_user === 1) && (
                <li>
                  <button className="dropdown-item" onClick={() => navigate("/profile")}>
                    Profile Settings
                  </button>
                </li>
              )}
              <li>
                <button className="dropdown-item" onClick={() => navigate("/login")}>Logout</button>
              </li>
            </ul>
          </div>
        </header>

        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
